import Collapsible from "@/collapsible/collapsible"

export default async () => {
  // header collapsibles
  global.headerCollapsibles = []
  Array.from(document.querySelectorAll('header .collapse')).forEach((collapsibleDiv)=>{
    const collapsible = new Collapsible(collapsibleDiv)
    collapsible.init()
    global.headerCollapsibles.push(collapsible)
  })

  // main page collapsibles
  global.mainPageCollapsibles = []
  Array.from(document.querySelectorAll('.main-page-collapse.collapse')).forEach((collapsibleDiv)=>{
    const collapsible = new Collapsible(collapsibleDiv)
    collapsible.init()
    global.mainPageCollapsibles.push(collapsible)
  })
}